
import PhoneHeader from './common/phoneHeader'
import PhoneMask from './common/phoneMask'
import pcHeader from './common/pcHeader'
import Confirm from './common/confirm'
import mixins from '../mixins/index'
import storage from '../mixins/storage'
import QRcode from 'qrcodejs2'


export default {
name: 'home',
metaInfo: {
title: '认识新朋友,连接新世界',
meta: [
{
name: 'keywords',
content: 'DNAer,叮了,dnaer叮了,实名社交,数据资产,dnaer,DNAer官网'
},
{
name: 'description',
content: 'DNAer叮了，实名社交系统。真实的人人连接平台，纯粹实名，私密交往，认识朋友圈外的TA。'
}
]
},



mixins: [mixins],
components: {
Confirm,
PhoneHeader,
PhoneMask,
pcHeader
},
data () {
return {
modelIsShow:false,
isInterval: true,
interval: null,
isPhone: false,
screenHeight: null,
userId: 0,
isShowMask: false,
userList: [
{
name: '陈胜舟',
src: 'https://cdn2.dnaerapp.com/2021/01/10/15/0AC07741-5138-4BB2-B267-6E3640AA518F.jpg'
},
{
name: '徐慧芹',
src: 'https://cdn2.dnaerapp.com/2021/02/15/13/F4AF4330-E36C-4C39-B5C5-D0C032C77F85.jpg'
},
{
name: '左泽华',
src: 'https://cdn2.dnaerapp.com/2021/02/10/20/EE18D874-B50E-45DF-BBBA-2766E4E273F4.jpg'
},
{
name: '宋炳霞',
src: 'https://cdn2.dnaerapp.com/2021/01/09/22/40509DBE-F526-453A-87F7-AF8659FFE3FA.jpg'
},
{
name: '卓越',
src: 'https://cdn2.dnaerapp.com/2020/12/14/21/A81FEDEE-767E-4694-B3A4-DF0F5CB2D07D.jpg'
},
{
name: '范智慧',
src: 'https://cdn2.dnaerapp.com/2021/01/18/16/F52C3CEB-2DCB-4E83-AC10-119AEA04FD4A.jpg'
},
{
name: '蒋海滨',
src: 'https://cdn2.dnaerapp.com/2020/12/14/21/8326A383-3CD1-4CF5-A5E2-C929095765E5.jpg'
},
{
name: '向文',
src: 'https://cdn3.dnaerapp.com/user/wechart/2020/12/21/17/pattern7750663452923330719.png'
},
{
name: '崔兴宇',
src: 'https://cdn2.dnaerapp.com/2020/09/06/14/ECF73625-D74C-49B2-9AFC-877A960507FB.jpg'
},
{
name: '卢晶晶',
src: 'https://cdn3.dnaerapp.com/user/wechart/2020/12/21/12/pattern7054270977005837290.png'
}
],


































userInfo: {
name: '陈胜舟',
src: 'https://cdn2.dnaerapp.com/2021/01/10/15/0AC07741-5138-4BB2-B267-6E3640AA518F.jpg'
},
isTitleInterval: true,
titleId: 0,
titleInfo:{
name: '叮了，连接新世界',
title: '我的叮了，我的品牌主页'
},
titleList: [
{
name: '实名制同学社交系统',
title: '8亿同学、校友通讯社交系统'
},
{
name: '秀真我，记录、分享精彩生活',
title: '实名、真实的同学连接平台'
},
{
name: '认识新同学、找到老同学',
title: '认识“朋友圈”外的TA'
},
{
name: '个人“数据资产银行”',
title: '我创造、我使用、我受益'
},
{
name: '亲人圈、同学圈、闺蜜圈',
title: '定向发布到好友圈组'
},
{
name: '我关心的，才是我的“世界”',
title: 'DNA数据基因推荐系统'
},
{
name: '新一代极致讯息系统',
title: '阅后即焚&更强大的群聊系统'
}
],
isOpen: false,
GetMobelType: null,
type: null,
downloadUrl: '',
iosDownLoadUrl:'https://apps.apple.com/cn/app/dnaer叮了-实名社交系统/id1479806321?l=zh&ls=1',
codeUrl: 'https://dnaerapp.com/#/'
}
},
mounted () {
console.log('欢迎进入DNAer官网!')
console.log('test!')
this.handleGetMobelType()
this.handleGetNewVersion()
this.isInterval = true
this.isTitleInterval = true
this.handleIsTitleReturn()
this.handleReturn()

if (this.handleIsPhone()) {
this.isPhone = true
this.screenHeight = window.screen.height
} else {
this.isPhone = false
}
this.handleGetjsapiTicket()
},
methods: {
handleToWeb () {
location.href = 'http://pc.dnaerapp.com/#/'
},
handleChangeMaskShow () {
this.isShowMask = !this.isShowMask
},
handleAddDownNum () {
this.axios('/sale/brand/propaganda/admin/v1/add/downloads',{brandPropagandaId: '1199164980390400000'}).then(res=>{
console.log(res.data)
})
},
qrcode () {
let qrcode = new QRcode('qrcode', {
width: 240,
height: 240, // 高度
text: this.codeUrl ,// 二维码内容

background: '#f0f',
foreground: '#ff0'
})
},
handleGetToken () {
this.axios('/basics/weixin/token/v1/str',{}).then(res=>{
let {data} = res.data
storage.setAccessToken(data.access_token)
})
},
handleMouseOverBtn (value) {
let qrcodeDiv = document.getElementById('qrcodeDiv')
qrcodeDiv.style.opacity = '1'
if (value === 'ios') {
document.getElementById("qrcode").innerHTML = "";
this.codeUrl = 'https://dnaerapp.com/#/'
console.log(this.codeUrl)
this.qrcode()
} else {
document.getElementById("qrcode").innerHTML = "";
this.codeUrl = 'https://dnaerapp.com/#/'
console.log(this.codeUrl)
this.qrcode()
}
},
handleMouseLeaveBtn () {
let qrcodeDiv = document.getElementById('qrcodeDiv')
qrcodeDiv.style.opacity = 0

},
handleGetjsapiTicket () {
this.axios('/basics/weixin/token/v1/jsapi',{}).then(res=>{
let {data} = res.data
storage.setAccessTicket(data.ticket)
let date = Date.parse(new Date)/1000
let info = {
jsapi_ticket: data.ticket,
noncestr: 'Wm3WZYTPz0wzccnW',
timestamp: date,
url: window.location.href,
string1: 'jsapi_ticket='+data.ticket +'&noncestr=Wm3WZYTPz0wzccnW&timestamp='+ date+'&url=' + window.location.href,
signature: mixins.sha1('jsapi_ticket='+data.ticket +'&noncestr=Wm3WZYTPz0wzccnW&timestamp='+ date+'&url=' + window.location.href)
}
let wx = window.wx
wx.config({
debug: false,
appId: 'wx8f1a3d5e394c3750', // 必填，公众号的唯一标识
timestamp:date, // 必填，生成签名的时间戳
nonceStr: info.noncestr, // 必填，生成签名的随机串
signature:info.signature ,// 必填，签名，见附录1
jsApiList: ['updateAppMessageShareData'] 
})

wx.ready(function () {//需在用户可能点击分享按钮前就先调用
wx.updateAppMessageShareData({
'imgUrl': 'https://www.dnaerapp.com/static/img/logo.png', // 这里是需要展示的图标
'desc': 'DNAer叮了，实名社交系统。真实的人人连接平台，纯粹实名，私密交往，认识朋友圈外的TA。', // 这是分享展示的摘要
'title': 'DNAer,叮了,dnaer叮了,实名社交,数据资产', // 这是分享展示卡片的标题
'link': 'https://www.dnaerapp.com/', // 这里是分享的网址
success: function (res) {

},
error: function (res) {
}
})
});
})
},
handleGetNewVersion () {
this.axios('/plugin/unCheck/app/version/mobile/v1/lastOne',{platform: 'android'}).then((res) => {
this.downloadUrl = res.data.data.url
})
},
handlePhoneJump () {
let _this = this
if (this.GetMobelType.weixin) {
this.isShowMask = true
} else {
if (this.GetMobelType.android) {
window.location.href = _this.downloadUrl
}
if (this.GetMobelType.ios || this.GetMobelType.iPhone || this.GetMobelType.iPad) {
if (this.GetMobelType.qq) {
this.isShowMask = true
} else {
window.location.href = 'https://apps.apple.com/cn/app/dnaer叮了-实名社交系统/id1479806321?l=zh&ls=1'
}
}
}
},
handleGetMobelType () {
let browser = { }
let u = window.navigator.userAgent
browser = {
trident: u.indexOf('Trident') > -1,
presto: u.indexOf('Presto') > -1,
Alipay: u.indexOf('Alipay') > -1,
webKit: u.indexOf('AppleWebKit') > -1,
gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
mobile: !!u.match(/AppleWebKit.*Mobile.*/),
ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
iPad: u.indexOf('iPad') > -1,
webApp: u.indexOf('Safari') === -1,
weixin: u.indexOf('MicroMessenger') > -1,
qq: u.match(/\sQQ/i) !== null,
Safari: u.indexOf('Safari') > -1
}
this.GetMobelType = browser
this.type = this.GetMobelType.android


},
handlePhoneBtnClick () {
this.$refs.myConfirm.show('暂无权限!', '取消')
},
handleIsPhone() {
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
return flag;
},
handleIosBtnClick () {

this.handleAddDownNum()
var ifrs = document.createElement('iframe')
ifrs.src = ''
ifrs.style.display = 'none'
window.location.href = 'https://apps.apple.com/cn/app/dnaer叮了-实名社交系统/id1479806321?l=zh&ls=1'

},
handleAndroidBtnClick () {
this.handleAddDownNum()
let _this = this
var u = navigator.userAgent.toLocaleLowerCase()
var isWeixin = u.match(/MicroMessenger/i) === 'micromessenger'
if (this.GetMobelType.weixin) {
this.$refs.myConfirm.show('请在浏览器中打开', '取消')
} else  {
window.location.href = 'dnaer://com.dnaer.h5/h5.html'
window.setTimeout(function () {
window.location.href = _this.downloadUrl
}, 100)
}
},
handleAndroidBtnClickPc () {
window.location.href = this.downloadUrl
},
handleModalFalse () {
this.modelIsShow = false
},
handleModalTrue () {
this.modelIsShow = true
},
handleReturn () {
setInterval(function () {
if (this.isInterval) {
if (this.userId < 7) {
this.userId = this.userId + 1
} else {
this.userId = 0
}
this.userInfo = this.userList[this.userId]
}
}.bind(this), 3000)
},
handleIsTitleReturn () {
setInterval(function () {
if (this.isTitleInterval) {
if (this.titleId < 6) {
this.titleId = this.titleId + 1
} else {
this.titleId = 0
}

}
}.bind(this), 3000)
},
handleToCommunity () {
this.$router.push({name: 'community'})
},
handleToUser () {
this.$router.push({name: 'userProtocol'})
},
handleToPricacy () {
this.$router.push({name: 'privacy'})
},
handleToHome () {
this.$router.push({name: 'home'})
},
handleGetOpen (data) {
this.isOpen = data
}
},
destroyed () {
this.isInterval = false
this.isTitleInterval = false
}
}



// WEBPACK FOOTER //
// ./src/components/home.vue